import React from "react";
import { Carousel } from 'react-bootstrap';
import "./certificateinoptician.css";


import CCourseimg1 from '../../assets/Pathway.jpg';
import CCourseimg2 from '../../assets/courseheaderimg1.png';
import CCourseimg3 from '../../assets/courseheaderimg2.png';
import CCourseimg4 from '../../assets/courseheaderimg3.png';


function RPLCourse () {

  return (
    <>


      <div className="banner-certificate">
        {/* Auto Sliding Banner */}
        <Carousel className="mb-5">
          <Carousel.Item>
            <img
              className="d-block w-100 "
              src={CCourseimg1}
              alt="First slide"
            />
  
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={CCourseimg2}
              alt="Second slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={CCourseimg3}
              alt="Third slide"
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={CCourseimg4}
              alt="Fourth slide"
            />
          </Carousel.Item>
        </Carousel>
      </div>

    <div className="certificate-container">
      <div className="header">
        <h1>Recognition of Prior Learning <br />(RPL - NVQ Level 3)</h1><br />
        <p>
       This is an experience-based course focused on training in ophthalmic dispensing, including spectacle and lens selection, measurements, adjustments, and patient guidance.
        </p>
      </div>

      <div className="section">
        <h2>Eligibility</h2>
        <p>
          The candidate must meet the following criteria:
        </p>
        <ul>
          {/* <li>Up to G.C.E. Ordinary Level.</li> */}

          <li>
            Minimum 2 years of industry experience 
          </li>
        
        </ul>
      </div>

      <div className="section">
        <h2>Duration</h2>
        <p>
          <strong>Six Months</strong>
           <ul>
            <li>Online & Physical</li>
                
            </ul>
        </p>
      </div>


      <section className="section">
        <h2>Course Fee</h2>
        <p>Course Fee: 80,000 LKR</p>
        {/* <p>Scholarship Programme Available | Terms and Conditions Applied</p> */}
      </section>

      <div className="section">
        <h2>Course Content</h2>

            <ul>
            <li>Unit 01 – Interpret the Prescription</li>
            <li>Unit 02 – Advise Customers in Selecting Frames</li>
            <li>Unit 03 – Select Lenses for Eyewear</li>
            <li>Unit 04 – Take Measurements to Fit Lenses into Optical Frames</li>
            <li>Unit 05 – Assess the Final Product (Eyewear)</li>
            <li>Unit 06 – Deliver Products and Promote Sales</li>
            <li>Unit 07 – Maintain Records and Carry Out Follow-up Actions</li>
            <li>Unit 08 – Adjust and Repair Eyewear</li>
            </ul>




      </div>

      <div className="section">
        <h2>Scope</h2>
        <p>
        This course is designed to provide training in ophthalmic dispensing,
        including spectacle and lens selection, measurements, adjustments, and
        patient guidance, preparing learners to work as Ophthalmic Opticians.
        It does not qualify graduates for independent practice.
        </p>
      </div>

      {/* <div className="section">
        <h2>Evaluation Pattern</h2>
        <ul>
          <li>Continuous Assignment</li>
          <li>Assignment</li>
          <li>VIVA VOCE</li>
          <li>Final Exam (Theory & Practical)</li>
        </ul>
      </div> */}
    </div>

    <div className="how-to-apply-container">
      <h2 className="section-title">How to Apply</h2>
      <div className="steps-container">
        <div className="step">
          <div className="circle orange">
          <span>&#x270F;</span>
          </div>
          <h3 className="step-title">REGISTRATION</h3>
          <p>
            <a
              href="/registration-course"
              style={{ textDecoration: 'none' }}
            >
              To Register
            </a>
          </p>
        </div>

        {/* <div className="step">
        <div className="circle green">
          <span>&#128441;</span>
        </div>
         <h3 className="step-title">Guidelines</h3>
        <a href="/Guidelines.pdf" download className="download-button" style={{ textDecoration: 'none' }}>
          Download Guidelines
        </a>
        <div className="download-pdf"></div> 
      </div> */}

      </div>
      <div className="contact-us">
        <a href="/contactus" className="contact-button text-decoration-none">
          Contact Us <span>&#x2192;</span>
        </a>
      </div>
    </div>


    </>
    
  );
}


export default RPLCourse